import { useCredentialingTranslation } from '../../ui/hooks/useCredentialingTranslation';
import { useFeatureFlags } from '../../ui/hooks/useFeatureFlags';
import { TextCell } from '@juvare/common-data-table-ui/DataTable';
import { useUserDirectoryColumns } from '@juvare/contact-management/ui/features/user-directory/hooks/useUserDirectoryColumns';
import { useContactManagementTranslation } from '@juvare/contact-management/ui/hooks/useContactManagementTranslation';
import { usePublicDataGet } from '@juvare/platform-sdk-react/ui/hooks';
import React from 'react';
export function useCredentialingUserDirectoryColumns() {
    const { t: cmT } = useContactManagementTranslation();
    const { t } = useCredentialingTranslation();
    const userDirectoryColumns = useUserDirectoryColumns();
    const { tribe: tribeEnabled } = useFeatureFlags();
    const { data: tribes, isLoading } = usePublicDataGet('classifier-tribe');
    return React.useMemo(() => {
        if (tribeEnabled && !isLoading && tribes) {
            return [
                ...userDirectoryColumns.filter((column) => column.headerLabel !== cmT('panels.userDirectory.columnLabels.county')),
                {
                    headerLabel: t('table.userDirectory.columnLabels.countyOrTribe'),
                    cellFunction: (row) => {
                        var _a;
                        return (React.createElement(TextCell, null, row.tribeId ? (_a = tribes.find((tribe) => tribe.value === row.tribeId)) === null || _a === void 0 ? void 0 : _a.label : row.county));
                    },
                },
            ];
        }
        else {
            return userDirectoryColumns;
        }
    }, [tribeEnabled, isLoading, tribes, userDirectoryColumns, t, cmT]);
}
